// Mock data for services
export const mockServices = [
  {
    id: 'basic',
    name: 'Basic Detail',
    price: 80,
    duration: '1-2 hours',
    description: 'Essential cleaning and protection for your vehicle',
    features: [
      'Exterior hand wash',
      'Wheel and tire cleaning',
      'Interior vacuum',
      'Dashboard and console wipe',
      'Window cleaning (inside & out)',
      'Tire shine'
    ]
  },
  {
    id: 'premium',
    name: 'Premium Detail',
    price: 200,
    duration: '4-5 hours',
    description: 'Comprehensive detailing for a showroom finish',
    features: [
      'Everything in Basic Detail',
      'Clay bar treatment',
      'Machine polish',
      'Paint sealant protection',
      'Deep interior cleaning',
      'Leather conditioning',
      'Engine bay cleaning',
      'Headlight restoration'
    ]
  },
  {
    id: 'luxury',
    name: 'Luxury Detail',
    price: 700,
    duration: '1 day or more',
    description: 'Ultimate care and protection for luxury vehicles',
    features: [
      'Everything in Premium Detail',
      'Ceramic coating application',
      'Paint correction (stage 1)',
      'Premium interior protection',
      'Odor elimination treatment',
      'Fabric protection',
      'Chrome polishing',
      'Undercarriage wash',
      '30-day warranty'
    ]
  }
];

// Mock add-ons
export const mockAddOns = [
  { id: 'pet-hair', name: 'Pet Hair Removal', price: 50 },
  { id: 'stain-removal', name: 'Stain Removal', price: 100 },
  { id: 'paint-enhancement', name: 'Paint Enhancement Polish', price: 200 },
  { id: 'headlight-light', name: 'Headlight Restoration (Light)', price: 50 },
  { id: 'headlight-deep', name: 'Headlight Restoration (Deep)', price: 150 },
  { id: 'headlight-ppf', name: 'Headlight PPF Protection', price: 250 },
  { id: 'engine-bay', name: 'Engine Bay Detail', price: 50 },
  { id: 'ceramic-coating', name: 'Ceramic Coating', price: 200 },
  { id: 'chrome-polish', name: 'Chrome Polish', price: 50 },
  { id: 'odor-elimination', name: 'Odor Elimination (Ozone)', price: 150 }
];

// Mock time slots
export const mockTimeSlots = [
  { time: '8:00 AM', available: true },
  { time: '9:00 AM', available: true },
  { time: '10:00 AM', available: false },
  { time: '11:00 AM', available: true },
  { time: '12:00 PM', available: true },
  { time: '1:00 PM', available: true },
  { time: '2:00 PM', available: false },
  { time: '3:00 PM', available: true },
  { time: '4:00 PM', available: true }
];
